import ToolTip from "shared/components/common/ToolTip";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import React, { useState } from "react";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";
import ChevronUpIcon from "shared/components/icons/chevron/ChevronUpIcon";
import InfoIcon from "shared/components/icons/InfoIcon";

//This is one of the few cases we may NOT want to do ComponentPropsWithoutRef.
//The reason is we use this as a wrapper around other inputs where those inputs
//should really be the ones taking the ComponentPropsWithoutRef<"input">.

export type PillarFormInputWrapperProps = {
  name: string;
  label?: string | JSX.Element;
  labelClassName?: string;
  additionalClasses?: string;
  children?: React.ReactNode;
  handleChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  testid?: string;
  tooltip?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  placeholder?: any; //TODO: STYLING Remove this. It is not used here and should not be defined here.
  required?: boolean; //TODO: STYLING Remove this. It is not used here and should not be defined here.
  collapse?: boolean;
  errorMessage?: boolean;
};

const PillarFormInputWrapper = <T extends FormikValues = FormikValues>({
  name,
  label,
  labelClassName,
  additionalClasses,
  children,
  testid,
  tooltip,
  collapse = false,
  errorMessage,
}: PillarFormInputWrapperProps) => {
  const [isCollapse, setIsCollapse] = useState(false);
  const { errors } = useFormikContext<T>();
  const formikError = errors[name] ?? errorMessage;

  return (
    <div
      className={`flex flex-col ${additionalClasses ?? ""}`}
      data-testid={testid ? `${testid}-wrapper` : undefined}
    >
      {label && (
        <label
          className={`mb-0.25 ${labelClassName ?? "text-filter-label"} ${
            collapse ? "inline-flex items-center gap-x-0.5 cursor-pointer" : ""
          }`}
          htmlFor={name}
          onClick={() => {
            if (!collapse) return;
            setIsCollapse(!isCollapse);
          }}
        >
          {collapse &&
            (isCollapse ? (
              <ChevronUpIcon className="h-2.5 w-2.5" />
            ) : (
              <ChevronDownIcon className="h-2.5 w-2.5" />
            ))}
          <div className="flex items-center">
            {label}
            {tooltip && (
              <ToolTip
                className="cursor-pointer ml-1 flex items-center"
                tooltipClassName="mt-0.25 py-1 px-2 bg-neutral-light text-xs rounded-md border border-neutral-mid-300"
                tooltip={<div className="flex flex-col text-sm">{tooltip}</div>}
                placement="top-start"
              >
                <InfoIcon className="text-status-general-tint h-3 w-3" />
              </ToolTip>
            )}
          </div>
        </label>
      )}
      {collapse ? isCollapse && children : children}
      {formikError && (
        <ErrorMessage
          data-testid={`pillar-form-${name}-error`}
          name={name}
          component="span"
          className="text-danger-small"
        />
      )}
    </div>
  );
};

export default PillarFormInputWrapper;
